import { Navigate, useLocation } from 'react-router-dom';

export const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  const location = useLocation();
  
  if (!token) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  
  // Redirect /admin to /admin/dashboard
  if (location.pathname === '/admin') {
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
